module.exports = "/_next/static/images/apple-icon-114x114-ea98ee9aee9e939891dd546f60996891.png";